/* @flow */
/* eslint-env es6,browser */

import {
  PREBID_UID_PUBCOMMON,
  PREBID_UID_LIVERAMP,
  PREBID_UID_VERIZON,
  PREBID_UID_CRITEO,
  PREBID_UID_FABRICK,
  PREBID_UID_UNIFIEDID,
  IDP_COMMONID,
  IDP_LIVERAMP,
  IDP_PUBMATIC,
  IDP_VZM,
  USER_ID_VERIZON,
  USER_ID_CRITEO,
  USER_ID_FABRICK,
  USER_ID_UNIFIEDID,
  USER_ID_LIVERAMP
} from './idpconstants';
import idp from './idpmanager';
import { logDebug } from '../utils/logger';

/**
 * @param {string} idprovider - IDProvider name
 * @param {string} idpKey - Additional key required to fetch individual ID values multi ID providers
 * @returns {string} ID value
 */
function _getIDPId(idprovider: string = '', idpKey: string = '') {
  const id = idp.getUserID(idprovider, idpKey);
  logDebug(`Provider: ${idprovider}, key: ${idpKey}, value : ${id}`);
  return id;
}

/**
 *
 * @description geter for common ID
 * @returns {string} CommonID
 */
// eslint-disable-next-line import/prefer-default-export
function getCommonID(): string {
  return _getIDPId(IDP_COMMONID);
}

/**
 * @description Helper to get LiveRamp ID
 * @returns {string} LiveRampID
 */
function getLiveRampID(): string {
  return _getIDPId(IDP_PUBMATIC, USER_ID_LIVERAMP) || _getIDPId(IDP_LIVERAMP);
}

/**
 * @description Helper to get Criteo ID
 * @returns {string} CriteoID
 */
function getCriteoID(): string {
  return _getIDPId(IDP_PUBMATIC, USER_ID_CRITEO);
}

/**
 * @description Helper to get Fabrick ID
 * @returns {string} FabrickID
 */
function getFabrickID(): string {
  return _getIDPId(IDP_PUBMATIC, USER_ID_FABRICK);
}

/**
 * @description Helper to get Fabrick ID
 * @returns {string} FabrickID
 */
function getUnifiedID(): string {
  return _getIDPId(IDP_PUBMATIC, USER_ID_UNIFIEDID);
}

/**
 * @description Helper to get Verizon Connect ID
 * @returns {string} connectID
 */
function getConnectID(): string {
  return _getIDPId(IDP_VZM, USER_ID_VERIZON);
}

/**
 * @param {string} id - Prebid mapped ID
 * @returns  {string} - User ID
 */
export function getUserID(id: string = ''): string {
  let ret = '';
  if (id.length === 0) {
    return ret;
  }
  switch (id) {
    case PREBID_UID_PUBCOMMON:
      ret = getCommonID();
      break;
    case PREBID_UID_LIVERAMP:
      ret = getLiveRampID();
      break;
    case PREBID_UID_VERIZON:
      ret = getConnectID();
      break;
    case PREBID_UID_CRITEO:
      ret = getCriteoID();
      break;
    case PREBID_UID_FABRICK:
      ret = getFabrickID();
      break;
    case PREBID_UID_UNIFIEDID:
      ret = getUnifiedID();
      break;
    default:
      break;
  }
  return ret;
}

/**
 * @returns {object} Object of all userIDs
 */
export function getAllUserIDs() {
  const allUIDs = [
    PREBID_UID_PUBCOMMON,
    PREBID_UID_LIVERAMP,
    PREBID_UID_VERIZON,
    PREBID_UID_CRITEO,
    PREBID_UID_FABRICK,
    PREBID_UID_UNIFIEDID
  ];
  // get UIDs having valid values
  const ret = allUIDs.reduce((acc, v) => {
    const val = getUserID(v);
    if (val.length) {
      acc[v] = val;
    }
    return acc;
  }, {});
  return ret;
}
